import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=4af04c2a&scoped=true&"
import script from "./page-footer.vue?vue&type=script&lang=js&"
export * from "./page-footer.vue?vue&type=script&lang=js&"
import style0 from "./page-footer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./page-footer.vue?vue&type=style&index=1&id=4af04c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af04c2a",
  null
  
)

export default component.exports